import { render } from "./workflow-review-item.vue?vue&type=template&id=b3de452d"
import script from "./workflow-review-item.vue?vue&type=script&lang=js"
export * from "./workflow-review-item.vue?vue&type=script&lang=js"

import "./workflow-review-item.vue?vue&type=style&index=0&id=b3de452d&lang=css"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__